import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Clock, MessageSquare, Lock, Bot, ChevronLeft } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import './Participant.css';

export default function WelcomePage() {
  const { agentId } = useParams();
  const navigate = useNavigate();
  const { getAgent, addSession } = useApp();

  const agent = getAgent(agentId);

  const handleStart = async () => {
    const session = await addSession(agentId);
    if (session) {
      navigate(`/interview/${agentId}/chat?session=${session.id}`);
    }
  };

  if (!agent) {
    return (
      <div className="participant-bg">
        <div className="p-card">
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⚠️</div>
            <h2 style={{ color: 'var(--brown)', marginBottom: '0.5rem' }}>رابط المقابلة غير صالح</h2>
            <p style={{ color: 'var(--brown-muted)' }}>يبدو أن هذا الرابط منتهي أو غير صحيح</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="participant-bg">
      <div className="p-card animate-in">
        <div className="p-logo">
          <span>🍔</span>
          <span>هنقرستيشن</span>
        </div>

        <h1 className="p-title">مرحباً بك في مقابلة تجربة المستخدم</h1>
        <p className="p-desc">
          نريد معرفة رأيك في <strong>{agent.name}</strong> لتطوير تجربتنا وجعلها أفضل لك ولجميع المستخدمين.
        </p>

        <div className="info-list">
          <div className="info-row">
            <div className="info-icon"><Clock size={14} /></div>
            <span>مدة المقابلة تقريباً <strong>8–12 دقيقة</strong></span>
          </div>
          <div className="info-row">
            <div className="info-icon"><MessageSquare size={14} /></div>
            <span>المقابلة نصية بالكامل، لا يوجد فيديو أو صوت</span>
          </div>
          <div className="info-row">
            <div className="info-icon"><Lock size={14} /></div>
            <span>إجاباتك سرية وتُستخدم فقط لأغراض البحث الداخلي</span>
          </div>
          <div className="info-row">
            <div className="info-icon"><Bot size={14} /></div>
            <span>ستتحدث مع مساعد ذكاء اصطناعي متخصص بالأبحاث</span>
          </div>
        </div>

        <button className="btn btn-primary btn-lg btn-full" onClick={handleStart}>
          ابدأ المقابلة الآن
          <ChevronLeft size={18} />
        </button>

        <p className="p-privacy">
          بالنقر على "ابدأ" أنت توافق على أن إجاباتك ستُستخدم لأغراض تحسين المنتج
        </p>
      </div>
    </div>
  );
}
